import { InjectionToken } from "@angular/core";

export interface DashboardEndpoints {
    getIncidents: string;
}

export const DASHBOARD_ENDPOINTS = new InjectionToken<DashboardEndpoints>("Dashboard endpoints");
